/**
 * ストレージ・キャッシュ制限値の定数
 * ローカルストレージ、キャッシュ、ログなどの制限値を一元管理
 */

export const STORAGE_LIMITS = {
  /**
   * エラーログの制限
   */
  ERROR_LOG: {
    MAX_ENTRIES: 100, // 最大保存エントリ数
  },

  /**
   * PDFキャッシュの制限
   */
  PDF_CACHE: {
    MAX_SIZE: 5, // キャッシュ最大サイズ
  },

  /**
   * トースト通知の設定
   */
  TOAST: {
    MAX_VISIBLE: 4, // 同時表示最大数
    DEFAULT_DURATION: 5000, // デフォルト表示時間（ミリ秒）
  },
} as const;
